module.exports = __webpack_public_path__ + "img/immuTest3.76199f03.png";